import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import React from 'react';
import { Flex } from '@finect/tabular-core/Flex';
import { AppLink } from '@finect/tabular-core/AppLink';
import { getProductTransactionableOrganizations } from '../../../utils';
import { Tooltip } from '../../../../Tooltip';
import { Icon } from './../../../../Icon';
import { InlineFlex, ViewMore, TooltipContent } from './partials';
export var ProductDistributors = function ProductDistributors(_ref) {
  var entity = _ref.entity,
    _ref$withLink = _ref.withLink,
    withLink = _ref$withLink === void 0 ? false : _ref$withLink,
    _ref$qty = _ref.qty,
    qty = _ref$qty === void 0 ? 2 : _ref$qty;
  var distributors = getProductTransactionableOrganizations(entity);
  var DistributorIcon = function DistributorIcon(distributor) {
    return React.createElement(Icon, {
      size: 0,
      alt: "company",
      type: "company",
      image: distributor.distributor ? "/image/".concat(distributor.distributor.icon) : null,
      margin: "0 4px 0 0",
      withBorder: true
    });
  };
  return React.createElement(InlineFlex, null, distributors.slice(0, qty).map(function (item, index) {
    if (withLink) {
      return React.createElement(AppLink, {
        key: index,
        href: "/grupos/".concat(item.alias),
        title: item.displayName
      }, React.createElement(DistributorIcon, {
        distributor: item
      }));
    }
    return React.createElement(DistributorIcon, {
      key: index,
      distributor: item
    });
  }), distributors.length > qty ? React.createElement(Tooltip, {
    tip: React.createElement(TooltipContent, null, "M\xE1s distribuidores", React.createElement(Flex, null, distributors.slice(qty).map(function (item, index) {
      return React.createElement(DistributorIcon, {
        key: index,
        distributor: item
      });
    }))),
    from: "left"
  }, React.createElement(ViewMore, null, "".concat(distributors.length - qty, " m\xE1s"))) : null);
};